import { fileApi } from "@/getinfo-api/index";

export interface FileApiSearchParams {
  diskId: string;
  pattern?: string;
  dir?: string;
  mimeTypes?: Array<string>;
  sizeMin?: number;
  sizeMax?: number;
  lastModifiedMin?: Date;
  lastModifiedMax?: Date;
  sort?: "name" | "path" | "modifiedAt" | "size";
  order?: "ASC" | "DESC";
  offset?: number;
  limit?: number;
  options?: any;
}

export default (params: FileApiSearchParams, options?: any) => {
  return fileApi.FileApiV2.search(
    params.diskId,
    params.pattern,
    params.dir,
    params.mimeTypes,
    params.sizeMin,
    params.sizeMax,
    params.lastModifiedMin,
    params.lastModifiedMax,
    params.sort,
    params.order,
    params.offset,
    params.limit
  );
};
